import { call, put, takeEvery } from 'redux-saga/effects'

function* storeData(action) {
    if (action.data) {
        yield put({ type: 'STORE_SELECTED_CATEGORY_SUCCESS', data: action.data });
    } else {
        yield put({ type: 'STORE_SELECTED_CATEGORY_FAILED', message: "no data" });
    }
}

function* categoryFilterSaga() {
    yield takeEvery('STORE_SELECTED_CATEGORY_REQUESTED', storeData);
}

export default categoryFilterSaga;